import { Component, OnInit, Input } from '@angular/core';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-details-general-info-crm',
  templateUrl: './order-details-general-info-crm.component.html',
  styleUrls: ['./order-details-general-info-crm.component.css']
})
export class OrderDetailsGeneralInfoCrmComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  constructor() { }
  ngOnInit() { }

}
